export default __webpack_public_path__ + "static/media/avails.472a76c1.png";